import { createFileRoute } from '@tanstack/react-router'


import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import InviteRequests from "@/modules/invite-feedback/requests";
import {inviteRequestsQueryOptions} from "@/modules/invite-feedback/requests/hooks";
import {
  defaultFetchParamsInviteRequests,
  InviteRequestsSearch,
  mergedInviteRequestsSchema,
} from "@/types/route-search-schemas";
import {DataLoader} from "@/types/router-context";
import {REVIEW_INVITE_REQUESTS_PATH, REVIEW_INVITE_REQUESTS_URL} from "@/utils/urls";

export const Route = createFileRoute(REVIEW_INVITE_REQUESTS_PATH)({
  component: InviteRequestsPage,
  validateSearch: (search: Record<string, unknown>): InviteRequestsSearch => validateSearchWithDefaults(mergedInviteRequestsSchema, search),
  loader: ({ context: { queryClient } }: DataLoader) => {
    if (isCurrentPage(REVIEW_INVITE_REQUESTS_URL)) {
      return
    }
    queryClient.prefetchQuery(inviteRequestsQueryOptions(defaultFetchParamsInviteRequests))
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Invite feedback', path: '#' },
        { label: 'Invite requests', path: REVIEW_INVITE_REQUESTS_URL },
      ],
      children: null
    }
  },
})

function InviteRequestsPage() {
  return(
    <div className={'flex flex-col items-center justify-center'}>
      <InviteRequests />
    </div>
  )
}
